import UI_ACTIONS from '../data/UiActionConstants';
export default class UiAction {
  static byActionName = {};
  constructor(actionName) {
    if(UiAction.byActionName[actionName]) {
      throw "UI Action already exists, please choose a different actionName: From: src/app/ui/UiAction.js";
    }
    UiAction.byActionName[actionName] = this;
    this.actionName = actionName;
    this.menuItem = null;
    this.linkedUiPage = null;
  }

  isPermitted = (permissionsList) => {
    return permissionsList.indexOf(this.actionName) !== -1
  }

  setMenuItem = (menuItem) => {
    this.menuItem = menuItem;
  }

  linkUiPage = (uiPage) => {
    this.linkedUiPage = uiPage;
    uiPage.linkedUiAction = this;
  }

  getTitle = () => {
    console.log(UI_ACTIONS[this.actionName])
    return UI_ACTIONS[this.actionName]?.title;
  }
}
